import { h } from 'preact';

const WolficonArrowRightBold = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true">
        <path d="M64,295.34H306.36L202.49,392.92,256,448,448,256,256,64l-53.51,53.51,103.87,99.15H64Z" />
    </svg>
);

export default WolficonArrowRightBold;
